import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * SubdomainRouter
 *
 * Routes the entry path (`/`) based on hostname so the same SPA build can serve
 * three production faces from one codebase:
 *   - elearningsaham.my         → public landing (no redirect)
 *   - portal.elearningsaham.my  → student portal (sends `/` → `/login`)
 *   - admin.elearningsaham.my   → admin console (sends `/` → `/admin`)
 *
 * Authenticated routes still handle their own role gating via ProtectedRoute.
 * Non-matching subdomains (preview/dev) keep default landing behaviour.
 */
export function SubdomainRouter() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (location.pathname !== "/") return;

        const host = (window.location.hostname || "").toLowerCase();
        if (host === "portal.elearningsaham.my") {
            navigate("/login", { replace: true });
        } else if (host === "admin.elearningsaham.my") {
            // /admin is gated by ProtectedRoute → unauthenticated users are
            // bounced to /login automatically.
            navigate("/admin", { replace: true });
        }
    }, [navigate, location.pathname]);

    return null;
}
